import * as trace from 'owa-trace';
import { ActionMessage, DispatchFunction } from 'satcheljs';
import { intentionalActions } from 'mini-app-constants/lib/intentionalActions';
import { Modules } from 'mini-usercustomproperties';
import { updateModuleUserActivity } from 'mini-usercustomproperties/lib/api/updateModuleUserActivity';

/**
 * This middleware gets the module and intercepts all satchel actions and checks if they are intentional actions. If yes, then it stores it in SDS
 * @param modules Array of modules for which we need to track
 */

export const getSactchelIntentionalActionMiddleware = (modules: Modules[]) => (
    next: DispatchFunction,
    actionMessage: ActionMessage
): void => {
    const { type: actionName } = actionMessage;

    try {
        modules?.forEach(module => {
            if (intentionalActions[module].includes(actionName)) {
                updateModuleUserActivity(module);
            }
        });
    } catch (e) {
        trace.errorThatWillCauseAlert(
            'UpdateModuleUserActivity failed in satchelIntentionalActionTrackerMiddleware for module: ' +
                modules?.join(',')
        );
    }

    // Pass the control to next middleware in the sequence.
    next(actionMessage);
};
